import {
  ADDTOCART,
  CARTDECREMENT,
  CARTINCREMENT,
  REMOVEFROMCART,
} from "./actionTypes";

export const addToCart = (id, quantity, stock) => {
  return {
    type: ADDTOCART,
    payload: {
      id,
      quantity,
      stock,
    },
  };
};
export const removeFromCart = (id) => {
  return {
    type: REMOVEFROMCART,
    payload: {
      id,
    },
  };
};
export const cartIncrement = (id) => {
  return {
    type: CARTINCREMENT,
    payload: {
      id,
    },
  };
};
export const cartDecrement = (id) => {
  return {
    type: CARTDECREMENT,
    payload: {
      id,
    },
  };
};
